import { render, staticRenderFns } from "./AiConsult.vue?vue&type=template&id=4df7eccd&scoped=true"
import script from "./AiConsult.vue?vue&type=script&lang=js"
export * from "./AiConsult.vue?vue&type=script&lang=js"
import style0 from "./AiConsult.vue?vue&type=style&index=0&id=4df7eccd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4df7eccd",
  null
  
)

export default component.exports